export const useFocusRing = () => {
  return {
    focusProps: {},
    isFocusVisible: false
  };
};
//# sourceMappingURL=useFocusRing.js.map